<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<button type="button" data-toggle="tooltip" title="Отказ" class="btn btn-default" @click="goBack()"><i class="fa fa-times"></i></button>
					<button type="button" data-toggle="tooltip" title="Запис" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<ul class="nav nav-pills md-pills" role="tablist">
			<li class="nav-item"><a class="nav-link active" data-toggle="tab" role="tab" href="#basic">Профил</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#about">За нас</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#hs">Домашно образование</a></li>
			<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#upimg">Снимка</a></li>
		</ul>

		<div class="tab-content">
			<!-- Basic Info -->
			<div role="tabpanel" class="tab-pane active" id="basic">

				<div class="card">
					<div class="card-block">

						<div class="row">
							<div class="col-md-1">
								<f-image v-model="family.avatar" src-default="/network/static/img/default_family.jpg"></f-image>
							</div>
							<div class="col-md-11">
								<h4 class="card-title">{{$t('label.family_name')}}</h4>
								<f-input v-model="family.name" name="family_name" hide-name v-validate="'required'" :errors="errorBag.collect('family_name')" cplaceholder="(пример: Иван и Мария Иванови)">
								</f-input>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<h4 class="card-title">{{$t('label.family_people')}}</h4>

								<div class="form-group">
									<h5 class="card-sub-title">{{$t('label.family_parents')}}</h5>
									<div class="table-responsive">
										<table class="table table-bordered">
											<thead>
												<tr>
													<th class="text-center" style="width: 6ex">Роля</th>
													<th class="text-center">{{$t('label.person_name')}}</th>
													<th class="text-center">{{$t('label.person_interests')}}</th>
													<th class="text-center">{{$t('label.person_photo')}}</th>
													<th class="text-center"></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(roleDescription, role) in $config.lists.familyRoles">
													<template v-for="user in usersByRole[role]">
														<td class="vertical-middle">
															<span>{{ roleDescription.text }}</span>
															<!-- label class="custom-control custom-radio">
																<input type="radio" class="custom-control-input" v-model="family.role" :value="role">
																<span class="custom-control-indicator" :class="{'bg-success': family.role === role}"></span>
																<span class="custom-control-description">{{ roleDescription.text }}</span>
															</label -->
														</td>
														<td class="vertical-middle">
															<f-input v-model="user.name" name="person_name" hide-name v-validate="'required'" :errors="errorBag.collect('person_name', 'user.' + user.id)" :cplaceholder="'(пример: ' + roleDescription.placeholder + ')'" :data-vv-scope="'user.' + user.id"></f-input>
														</td>
														<td class="vertical-middle">
															<f-input v-model="user.interests" cplaceholder="(разделени със запетая)"></f-input>
														</td>
														<td>
															<f-image v-model="user.avatar" src-default="/network/static/img/default.jpg"></f-image>
														</td>
													</template>
													<template v-if="usersByRole[role].length === 0">
														<td colspan="5" class="text-center">
															<button class="btn btn-info" @click="addParent(role)"><i class="fa fa-plus"></i> {{roleDescription.text}}</button>
														</td>
													</template>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12 form-group">
								<h5 class="card-sub-title">{{$t('label.family_children')}}</h5>

								<div class="table-responsive">
									<table class="table table-bordered table-hover">
										<thead>
											<tr>
												<th class="text-center" style="width: 6ex">#</th>
												<th class="text-center">{{$t('label.person_name')}}</th>
												<th class="text-center">{{$t('label.person_sex')}}</th>
												<th class="text-center">{{$t('label.person_birth_year')}}</th>
												<th class="text-center"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(child, key) in usersByRole.child">
												<td class="text-center vertical-middle">{{ key + 1 }}</td>
												<td class="vertical-middle">
													<f-input v-model="child.name" name="person_name" hide-name v-validate="'required'" :errors="errorBag.collect('person_name', 'user.' + child.id)" cplaceholder="Име" :data-vv-scope="'user.' + child.id"></f-input>
												</td>
												<td class="vertical-middle">
													<f-select v-model="child.role" name="person_sex" hide-name v-validate="'required'" :errors="errorBag.collect('person_sex', 'user.' + child.id)" :values="$config.lists.childRoles" :data-vv-scope="'user.' + child.id"></f-select>
												</td>
												<td class="vertical-middle">
													<f-input v-model="child.birthYear" name="person_birth_year" hide-name v-validate="'required'" :errors="errorBag.collect('person_birth_year', 'user.' + child.id)" :data-vv-scope="'user.' + child.id"></f-input>
												</td>
												<td class="vertical-middle">
													<button @click="removeChild(key)" class="btn btn-small btn-danger btn-icon remove"><i class="fa fa-remove"></i></button>
												</td>
											</tr>
											<tr>
												<td colspan="5" class="text-center">
													<button class="btn btn-info" @click="addChild()"><i class="fa fa-plus"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<h4 class="card-title">{{$t('label.family_location')}}</h4>

								<f-select v-model="family.country" :values="$config.lists.countries" name="family_country" v-validate="'required'" :errors="errorBag.collect('family_country')"></f-select>
								<f-select v-model="family.state" :values="$config.lists.states" name="family_state" v-validate="'required'" :errors="errorBag.collect('family_state')"></f-select>
								<f-input v-model="family.city" name="family_city" cplaceholder="(не е задължително)"></f-input>

								<h5 class="card-title">{{$t('label.family_social')}}</h5>
								<div class="table-responsive">
									<table class="table table-bordered table-hover">
										<thead>
											<tr>
												<th class="text-center">{{$t('label.family_social_network')}}</th>
												<th class="text-center">{{$t('label.family_social_url')}}</th>
												<th class="text-center"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(social, key) in family.info.social">
												<td class="vertical-middle">
													<f-select v-model="social.name" :values="$config.lists.socialNetworks"></f-select>
												</td>
												<td class="vertical-middle">
													<f-input v-model="social.url" cplaceholder="URL адрес"></f-input>
												</td>
												<td class="vertical-middle">
													<button @click="removeSocial(key)" class="btn btn-small btn-danger btn-icon remove"><i class="fa fa-remove"></i></button>
												</td>
											</tr>
											<tr>
												<td colspan="5" class="text-center">
													<button class="btn btn-info" @click="addSocial()"><i class="fa fa-plus"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
									<br>
								</div>

							</div>
						</div>

					</div> <!-- end card-block -->
				</div> <!-- end card -->
			</div>

			<!-- About -->
			<div role="tabpanel" class="tab-pane" id="about">
				<div class="card">
					<div class="card-block">
						<f-textarea v-model="family.info.about" name="family_about" :crows="20">
						</f-textarea>

						<f-textarea v-model="family.info.interests" name="family_interests" :crows="3">
						</f-textarea>
					</div>
				</div>
			</div>

			<!-- Homeschooling Information -->
			<div role="tabpanel" class="tab-pane" id="hs">
				<div class="card">
					<div class="card-block">

						<h5 class="card-sub-title">{{$t('label.family_experience')}}</h5>
						<f-input v-model="family.info.hsExperience" name="family_experience" hide-name v-validate="'numeric'" :errors="errorBag.collect('family_experience')" cplaceholder="(пример: 1)"></f-input>

						<hr>

						<h5 class="card-sub-title">{{$t('label.family_methods')}}</h5>
						<p>Моля, изберете методите за домашно образование, които използвате във вашето семейство.</p>
						<div class="row hs_method" v-for="(method, key) in $config.lists.hsmethods">
							<div class="col-md-3">
								<label class="custom-control custom-checkbox">
									<input type="checkbox" v-model="family.info.hsMethods" :value="key" class="custom-control-input">
									<span class="custom-control-indicator" :class="{'bg-success': family.info.hsMethods.indexOf(key) !== -1}"></span>
									<span class="custom-control-description"><strong style="color:black">{{ method.name }}</strong></span>
								</label>
							</div>
							<div class="col-md-8">
								{{ method.desc }}
							</div>
						</div>
					</div>
				</div> <!-- card end -->
			</div>

			<!-- Upload Images -->
			<div role="tabpanel" class="tab-pane" id="upimg">
				<div class="card">
					<div class="card-block">

						<f-image v-model="family.photo" src-default="/network/static/img/default_family_photo.jpg" :width="0" :height="300" :avatar="false" 	:upload-endpoint="'backend://family/' + family.id + '/photo'"></f-image>
					</div>
				</div> <!-- card end -->
			</div>

		</div><!-- tab panels end-->
	</div>

</div>
</template>

<script>
var Dropzone = require('vue2-dropzone');

module.exports = {
	data: function () {
		return {
			family: {
				name: '',
				users: [],
				country: undefined,
				state: undefined,
				city: '',
				info: {
					about: '',
					interests: '',
					hsExperience: 0,
					hsMethods: [],
					social: []
				}
			},
			dataReady: false
		};
	},
	components: {
		Dropzone
	},
	computed: {
		usersByRole: function () {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		goBack: function () {
			// TODO: check for changes
			this.$router.push('/family/me');
		},
		fetchData: function () {
			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://family/' + familyId).then((response) => {
				this.family = response.body;
				if (this.family.info.social === undefined) {
					this.family.info.social = [];
					this.addSocial();
				}
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		addParent: function (role) {
			this.family.users.push({name: '', role: role, interests: '', id: 0});
			this.family.role = this.family.role || role;
		},
		addChild: function () {
			this.family.users.push({name: '', role: 'son', birthYear: 2000, id: 0});
		},
		removeChild: function (childIndex) {
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					if (childIndex === 0) {
						this.family.users.splice(i, 1);
						return;
					}
					childIndex--;
				}
			}
		},
		addSocial: function () {
			this.family.info.social.push({name: '', url: ''});
		},
		removeSocial: function (currentIndex) {
			this.family.info.social.splice(currentIndex, 1);
		},
		onSubmit: function () {
			for (let i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[ i ];
				if (member.name === '') {
					this.family.users.splice(i, 1);
					i--;
				}
			}
			if (this.usersByRole.mother.length === 0 && this.usersByRole.father.length === 0) {
				this.$toasted.show('Моля, попълнете името на поне един родител').goAway(1500);
				return;
			}
			for (let i = 0; i < this.family.info.social.length; i++) {
				var socialContact = this.family.info.social[ i ];
				if (socialContact.name === '') {
					this.family.info.social.splice(i, 1);
					i--;
				}
			}

			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.put('backend://family/' + this.family.id, this.family).then(function (response) {
					this.$router.push('/family/me');
				}).catch(this.$http.toastCatcher);
			});
		}
	}
};
</script>
<style>
.hs_method {
	border-bottom: 2px solid #eee;
	padding: 7px;
}
</style>



// WEBPACK FOOTER //
// FamilyProfileEdit.vue?6635cae4